/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_CurrentInputs */

const en_us2_swap_current = /** @type {(inputs: Swap_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const pt_br2_swap_current = /** @type {(inputs: Swap_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atual`)
};

const es_419_swap_current = /** @type {(inputs: Swap_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

const pt_pt2_swap_current = /** @type {(inputs: Swap_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atual`)
};

const fr_fr2_swap_current = /** @type {(inputs: Swap_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuel`)
};

const de_de2_swap_current = /** @type {(inputs: Swap_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell`)
};

const it_it2_swap_current = /** @type {(inputs: Swap_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attuale`)
};

/**
* | output |
* | --- |
* | "Current" |
*
* @param {Swap_CurrentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_current = /** @type {((inputs?: Swap_CurrentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_CurrentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_current(inputs)
	if (locale === "es-419") return es_419_swap_current(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_current(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_current(inputs)
	if (locale === "de-DE") return de_de2_swap_current(inputs)
	if (locale === "it-IT") return it_it2_swap_current(inputs)
	return en_us2_swap_current(inputs)
});
export { swap_current as "swap.current" }